
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/ai-game-assets-generator",
      function () {
        return require("private-next-pages/resources/ai-game-assets-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/ai-game-assets-generator"])
      });
    }
  